export default __webpack_public_path__ + "static/media/whitepaperImg.5b25c0ae.png";